/*
 ** file : msrp message chunk manager under javascript
 ** author : Nafise Kian
 ** date : September 2024
 */

 class ChunkManager {
  constructor() {
    this.chunkHead = null;
    this.chunkTail = null;
    this.MAX_CHUNK_SIZE = 2048;
    this.encoder = new TextEncoder();
    this.decoder = new TextDecoder();
  }

  getChunkHead() {
    let ref = this.chunkHead;
    while (ref && ref.prev !== null) {
      ref = ref.prev;
    }
    return ref;
  }

  getChunkTail() {
    let ref = this.chunkTail;
    while (ref && ref.next !== null) {
      ref = ref.next;
    }
    return ref;
  }

  addChunk(newChunk) {
    if (!this.chunkHead) {
      this.chunkHead = newChunk;
      this.chunkTail = newChunk;
    } else {
      let tail = this.getChunkTail();
      tail.next = newChunk;
      newChunk.prev = tail;
      this.chunkTail = newChunk;
    }
  }

  _findChunkBoundary(str, startCharIndex, maxBytes) {
    let end = startCharIndex;
    let lastGood = startCharIndex;
    while (end <= str.length) {
      const slice = str.slice(startCharIndex, end);
      const bytes = this.encoder.encode(slice);
      if (bytes.length > maxBytes) break;
      lastGood = end;
      end++;
    }
    if (lastGood === startCharIndex) {
      lastGood = startCharIndex + 1;
    }
    return lastGood; 
  }

  createChunks(message) {
    let charOffset = 0;
    const totalBytes = this.encoder.encode(message).length;
    let chunkCount = 0;

    while (charOffset < message.length) {
      const nextCharBoundary = this._findChunkBoundary(
        message,
        charOffset,
        this.MAX_CHUNK_SIZE
      );
      const chunkStr = message.slice(charOffset, nextCharBoundary);
      const chunkBytes = this.encoder.encode(chunkStr);
      const byteRangeStart = this.encoder.encode(message.slice(0, charOffset)).length + 1; // 1-based
      const byteRangeEnd = byteRangeStart + chunkBytes.length - 1;

      const chunk = {
        byteRangeStart: byteRangeStart,
        byteRangeEnd: byteRangeEnd,
        byteRangeTotal: totalBytes,
        msgContent: chunkStr,
        contFlag: byteRangeEnd === totalBytes ? "$" : "+",
        next: null,
        prev: null,
      };

      this.addChunk(chunk);
      charOffset = nextCharBoundary;
      chunkCount++;

      console.log(
        `Created chunk ${chunkCount} from ${chunk.byteRangeStart} to ${chunk.byteRangeEnd} (total ${totalBytes})`
      );
    }
  }

  isComplete() {
    let ref = this.getChunkHead();
    if (!ref || ref.byteRangeStart !== 1) return false;

    let prevEnd = ref.byteRangeEnd;
    while (ref.next !== null) {
      ref = ref.next;
      if (ref.byteRangeStart !== prevEnd + 1) return false;
      prevEnd = ref.byteRangeEnd;
    }

    return (
      ref.byteRangeEnd === ref.byteRangeTotal && ref.contFlag === "$"
    );
  }

  getAllContent() {
    let ref = this.getChunkHead();
    let content = "";
    while (ref !== null) {
      content += ref.msgContent;
      ref = ref.next;
    }
    return content;
  }
}

export default ChunkManager;
